/* CW Uhren-Ankauf: ersetzt Hulks abgeschnittenes Advanced JS durch einen kleinen Asset-Loader. */
(function () {
  if (!/(^|\/)pages\/uhren-ankauf\/?$/.test(window.location.pathname)) {
    return;
  }

  var FORM_ID = 'Z3I3t3m344jsxhh3wkw9_g';
  var hulkFormBuilder = window.hulkFormBuilder;
  var forms = hulkFormBuilder && hulkFormBuilder.form_data;
  var formEntry = forms && forms['form_' + FORM_ID];
  var formData = formEntry && formEntry.form_data;
  var iframeThemeSettingsPatch = null;

  if (!formData) {
    return;
  }

  // Der A11y-Zusatz gilt für jedes Theme mit diesem Skript (auch Duplikate, Umbenennungen).
  // Fester Schlüssel, den der Code in der Hulk-App erwartet; nicht die aktuelle Theme-ID.
  var A11Y_HANDSHAKE_KEY = 199162134912;

  function enableIframeA11y(source) {
    var frame = document.querySelector('iframe[src*="formbuilder.hulkapps.com/corepage/customform"][src*="' + FORM_ID + '"]');
    if (!source || !frame || frame.contentWindow !== source) return;
    source.postMessage({ type: 'cw_hulk_v105_a11y_enable', formId: FORM_ID, themeId: A11Y_HANDSHAKE_KEY }, 'https://formbuilder.hulkapps.com');
  }

  function showSubmittedNotice(source) {
    var iframe = document.querySelector('iframe[src*="formbuilder.hulkapps.com/corepage/customform"][src*="' + FORM_ID + '"]');
    if (!iframe || iframe.contentWindow !== source || iframe.dataset.cwSubmitted === 'true') {
      return;
    }

    var strings = (window.themeVariables && window.themeVariables.strings) || {};
    var notice = document.createElement('div');
    var title = document.createElement('p');
    var text = document.createElement('p');

    notice.className = 'cw-form-submitted';
    notice.setAttribute('role', 'status');
    notice.tabIndex = -1;
    title.className = 'cw-form-submitted__title';
    title.textContent = strings.cwFormSubmittedTitle || '';
    text.className = 'cw-form-submitted__text';
    text.textContent = strings.cwFormSubmittedText || '';
    notice.appendChild(title);
    notice.appendChild(text);

    // Hulk lässt den Rahmen nach dem Absenden in voller Höhe leer stehen.
    iframe.dataset.cwSubmitted = 'true';
    iframe.style.display = 'none';
    iframe.parentNode.insertBefore(notice, iframe);
    notice.scrollIntoView({ block: 'center' });
    notice.focus({ preventScroll: true });
  }

  function handleIframeResize(event) {
    if (event.origin !== 'https://formbuilder.hulkapps.com' || !event.data) {
      return;
    }

    if (event.data.type === 'form_submitted' && event.data.payload && event.data.payload.form_id === FORM_ID) {
      showSubmittedNotice(event.source);
      return;
    }

    if (event.data.type === 'cw_hulk_v105_a11y_ready' && event.data.formId === FORM_ID) {
      enableIframeA11y(event.source);
    }

    if (event.data.formid === FORM_ID && iframeThemeSettingsPatch && window.FbThemeAppExtSettingsHash) {
      var currentSettings = window.FbThemeAppExtSettingsHash[FORM_ID] || {};
      window.FbThemeAppExtSettingsHash[FORM_ID] = Object.assign(currentSettings, iframeThemeSettingsPatch);
    }

    if (event.data.type !== 'cw_hulk_form_resize') {
      return;
    }

    if (event.data.formId !== FORM_ID) {
      return;
    }

    var height = Number(event.data.height);
    if (!Number.isFinite(height) || height < 200 || height > 10000) {
      return;
    }

    var iframe = document.querySelector('iframe[src*="formbuilder.hulkapps.com/corepage/customform"][src*="' + FORM_ID + '"]');
    if (!iframe || iframe.contentWindow !== event.source) {
      return;
    }

    iframe.style.height = Math.ceil(height) + 'px';
    iframe.style.minHeight = '0px';
  }

  window.addEventListener('message', handleIframeResize, false);

  function isEnglishPage() {
    return /(^|\/)en(\/|$)/.test(window.location.pathname);
  }

  function applyEnglishFormCopy() {
    if (!isEnglishPage()) {
      return;
    }

    formData.form_submit = 'Submit';
    formData.after_submit_msg = '<p>Thank you for your inquiry. Our team will contact you shortly.</p>';

    (formData.formElements || []).forEach(function (field) {
      if (!field) {
        return;
      }

      if (field.label === 'Vorname') field.label = 'First name';
      if (field.label === 'Nachname') field.label = 'Last name';
      if (field.label === 'E-Mail-Adresse') field.label = 'Email address';
      if (field.label === 'Telefon') field.label = 'Phone';
      if (field.label === 'Modell- und Referenznummer') field.label = 'Model and reference number';
      if (field.label === 'Preisvorstellung') field.label = 'Expected price';
      if (field.label === 'Beschreibung') field.label = 'Description';
      if (field.label === 'Fotos hinzufügen') field.label = 'Add photos';
      if (field.label === 'Wie sind sie auf unsere Ankaufseite aufmerksam geworden?') field.label = 'How did you hear about our purchase page?';
      if (field.label === 'Datenschutzerklärung akzeptieren') field.label = 'Accept privacy policy';
      if (field.label === 'Einwilligung zur Kontaktaufnahme') field.label = 'Consent to be contacted';

      if (field.sublabel === 'Sie können bis zu 10 Bilder hochladen') field.sublabel = 'You can upload up to 10 images';
      if (field.browse_btn === 'Bilder auswählen') field.browse_btn = 'Select images';

      if (field.infoMessage && field.infoMessage.indexOf('Bitte geben Sie hier eine kurze Beschreibung ein') !== -1) {
        field.infoMessage = 'Please enter a short description, for example condition, age, original accessories (box and papers) – if known.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ihre Bilder helfen uns bei einer genauen Einschätzung') !== -1) {
        field.infoMessage = 'Your photos help us make an accurate assessment. Allowed file formats: JPG, JPEG, PNG, SVG – up to 10 images.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ich willige ein, dass meine Angaben') !== -1) {
        field.infoMessage = 'I agree that my details may be processed to handle my request in accordance with the privacy policy. Your data will only be used for this request and will not be shared with third parties.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ich bin damit einverstanden, dass Sie mich') !== -1) {
        field.infoMessage = 'I agree that you may contact me by phone or email to process my request.';
      }

      if (field.values) {
        field.values = field.values
          .replace('Empfehlung', 'Recommendation')
          .replace('Direkt über unsere Website', 'Directly via our website')
          .replace('Online-Werbung', 'Online advertising')
          .replace('Keine Angabe', 'No answer');
      }
    });

    var shopMessages = hulkFormBuilder && hulkFormBuilder.settings_data && hulkFormBuilder.settings_data.shop_settings && hulkFormBuilder.settings_data.shop_settings.shop_customise_msgs && hulkFormBuilder.settings_data.shop_settings.shop_customise_msgs[0];

    if (shopMessages) {
      shopMessages.processing = 'Processing...';
      shopMessages.is_required = 'Is required';
      shopMessages.valid_data = 'Please enter valid data';
      shopMessages.valid_email = 'Please enter a valid email address';
      shopMessages.valid_phone = 'Please enter a valid phone number';
      shopMessages.error_form_submit = 'Error submitting the form';
      shopMessages.email_submitted = 'Email has already been submitted';
      shopMessages.please_select = 'Please select';
      shopMessages.your_response = 'Your response';
      shopMessages.submission_no = 'Submission number';
      shopMessages.referral_url = 'Referrer URL';
    }
  }

  function applyIframeDesignPatch() {
    var scope = '.hulk_form_' + FORM_ID;
    var english = isEnglishPage();
    var copy = english ? {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email address',
      phone: 'Phone',
      model: 'Model and reference number',
      price: 'Expected price',
      description: 'Description',
      upload: 'Add photos',
      selectFiles: 'Select files',
      source: 'How did you hear about our purchase page?',
      privacy: 'Accept privacy policy',
      contact: 'Consent to be contacted',
      country49: '+49 · Germany',
      country43: '+43 · Austria',
      country41: '+41 · Switzerland',
      country31: '+31 · Netherlands',
      country32: '+32 · Belgium',
      country33: '+33 · France',
      country39: '+39 · Italy',
      country34: '+34 · Spain',
      country44: '+44 · United Kingdom',
      country1: '+1 · USA / Canada'
    } : {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail-Adresse',
      phone: 'Telefon',
      model: 'Modell- und Referenznummer',
      price: 'Preisvorstellung',
      description: 'Beschreibung',
      upload: 'Fotos hinzufügen',
      selectFiles: 'Dateien auswählen',
      source: 'Wie sind Sie auf unsere Ankaufseite aufmerksam geworden?',
      privacy: 'Datenschutzerklärung akzeptieren',
      contact: 'Einwilligung zur Kontaktaufnahme',
      country49: '+49 · Deutschland',
      country43: '+43 · Österreich',
      country41: '+41 · Schweiz',
      country31: '+31 · Niederlande',
      country32: '+32 · Belgien',
      country33: '+33 · Frankreich',
      country39: '+39 · Italien',
      country34: '+34 · Spanien',
      country44: '+44 · Vereinigtes Königreich',
      country1: '+1 · USA / Kanada'
    };

    function content(value) {
      return JSON.stringify(value);
    }

    var parentViewportWidth = window.innerWidth || document.documentElement.clientWidth || 1440;
    var cssPatch = [
      'html,body{width:100%!important;margin:0!important;padding:0!important;overflow-x:hidden!important;background:transparent!important;}',
      scope + ',' + scope + ' *{box-sizing:border-box!important;}',
      scope + '{width:100%!important;max-width:720px!important;margin:0 auto!important;padding:0!important;background:transparent!important;color:#0e0e0e!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:15px!important;line-height:1.6!important;font-feature-settings:"ss01","cv11"!important;-webkit-font-smoothing:antialiased!important;}',
      scope + ' .formContainer,' + scope + ' #formGeneratorForm,' + scope + ' .form_generater_form_div,' + scope + ' .tab,' + scope + ' .form-layout-wrapper,' + scope + ' .form-layout-content-col,' + scope + ' .form_element{width:100%!important;max-width:none!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;box-shadow:none!important;background:transparent!important;}',
      scope + ' .row,' + scope + ' .form_container{margin:0!important;}',
      scope + ' .formElement_0,' + scope + ' .formElement_1,' + scope + ' .formElement_2,' + scope + ' .formElement_3,' + scope + ' .formElement_4,' + scope + ' .formElement_5,' + scope + ' .formElement_6,' + scope + ' .formElement_7,' + scope + ' .formElement_9,' + scope + ' .formElement_11,' + scope + ' .formElement_13{float:none!important;width:100%!important;min-height:0!important;margin:0 0 22px!important;padding:0!important;clear:both!important;}',
      scope + ' .formElement_8,' + scope + ' .formElement_10,' + scope + ' .formElement_12,' + scope + ' .formElement_14{display:none!important;}',
      scope + ' .formElement_0,' + scope + ' .formElement_1{float:left!important;clear:none!important;width:calc(50% - 11px)!important;}',
      scope + ' .formElement_0{margin-right:22px!important;}',
      scope + ' .block_label{display:block!important;position:static!important;transform:none!important;margin:0 0 8px!important;padding:0!important;color:transparent!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:0!important;font-weight:600!important;line-height:1.6!important;letter-spacing:.01em!important;}',
      scope + ' .block_label:before{color:#0e0e0e!important;font-size:13px!important;}',
      scope + ' .block_label:after{color:#b8332b!important;font-size:13px!important;}',
      scope + ' .block_label:before,' + scope + ' .block_label:after,' + scope + ' .formElement_7:before,' + scope + ' .formElement_11 label[for="Checkbox_11"]:before,' + scope + ' .formElement_11 label[for="Checkbox_11"]:after,' + scope + ' .formElement_13 label[for="Checkbox_13"]:before,' + scope + ' .formElement_13 label[for="Checkbox_13"]:after{font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:13px!important;font-weight:600!important;line-height:1.6!important;letter-spacing:.01em!important;font-feature-settings:"ss01","cv11"!important;-webkit-font-smoothing:antialiased!important;}',
      scope + ' .formElement_0>.block_label:before{content:' + content(copy.firstName) + ';}',
      scope + ' .formElement_1>.block_label:before{content:' + content(copy.lastName) + ';}',
      scope + ' .formElement_2>.block_label:before{content:' + content(copy.email) + ';}',
      scope + ' .formElement_3>.block_label:before{content:' + content(copy.phone) + ';}',
      scope + ' .formElement_4>.block_label:before{content:' + content(copy.model) + ';}',
      scope + ' .formElement_5>.block_label:before{content:' + content(copy.price) + ';}',
      scope + ' .formElement_6>.block_label:before{content:' + content(copy.description) + ';}',
      scope + ' .formElement_9 legend.block_label:before{content:' + content(copy.source) + ';}',
      scope + ' .formElement_0>.block_label:after,' + scope + ' .formElement_1>.block_label:after,' + scope + ' .formElement_2>.block_label:after,' + scope + ' .formElement_4>.block_label:after,' + scope + ' .formElement_6>.block_label:after,' + scope + ' .formElement_9 legend.block_label:after{content:" *";}',
      scope + ' input.form-control,' + scope + ' select.form-control,' + scope + ' textarea.form-control{display:block!important;width:100%!important;margin:0!important;padding:13px 15px!important;border:1px solid #e5e5e5!important;border-radius:0!important;outline:0!important;box-shadow:none!important;background:#fff!important;color:#0e0e0e!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:15px!important;font-weight:400!important;line-height:24px!important;transition:border-color 200ms cubic-bezier(.4,0,.2,1)!important;}',
      scope + ' input.form-control,' + scope + ' select.form-control{height:52px!important;}',
      scope + ' textarea.form-control{height:148px!important;min-height:148px!important;resize:vertical!important;}',
      scope + ' input.form-control::placeholder,' + scope + ' textarea.form-control::placeholder{color:transparent!important;opacity:0!important;}',
      scope + ' input.form-control:focus,' + scope + ' select.form-control:focus,' + scope + ' textarea.form-control:focus{border-color:#0e0e0e!important;}',
      scope + ' .phone_div{display:grid!important;grid-template-columns:minmax(0,210px) 1fr!important;gap:10px!important;width:100%!important;margin:0!important;}',
      scope + ' .phone_div:before,' + scope + ' .phone_div:after{display:none!important;content:none!important;}',
      scope + ' .phone_div>div{float:none!important;width:auto!important;margin:0!important;padding:0!important;}',
      scope + ' .phone_div>div:first-child{position:relative!important;}',
      scope + ' select[name="dial_code"]{color:#0e0e0e!important;padding-right:38px!important;}',
      scope + ' select[name="dial_code"] option{color:#0e0e0e!important;}',
      scope + ' select[name="dial_code"]:has(option:is([value="+49"],[value="+43"],[value="+41"],[value="+31"],[value="+32"],[value="+33"],[value="+39"],[value="+34"],[value="+44"],[value="+1"]):checked){color:transparent!important;}',
      scope + ' .phone_div>div:first-child:after{position:absolute;z-index:2;top:50%;left:15px;max-width:calc(100% - 54px);overflow:hidden;color:#0e0e0e;font-family:Inter,"Helvetica Neue",system-ui,sans-serif;font-size:15px;line-height:24px;white-space:nowrap;text-overflow:ellipsis;transform:translateY(-50%);pointer-events:none;}',
      scope + ' .phone_div>div:first-child:has(option[value="+49"]:checked):after{content:' + content(copy.country49) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+43"]:checked):after{content:' + content(copy.country43) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+41"]:checked):after{content:' + content(copy.country41) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+31"]:checked):after{content:' + content(copy.country31) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+32"]:checked):after{content:' + content(copy.country32) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+33"]:checked):after{content:' + content(copy.country33) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+39"]:checked):after{content:' + content(copy.country39) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+34"]:checked):after{content:' + content(copy.country34) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+44"]:checked):after{content:' + content(copy.country44) + ';}',
      scope + ' .phone_div>div:first-child:has(option[value="+1"]:checked):after{content:' + content(copy.country1) + ';}',
      scope + ' .formElement_6{display:flex!important;flex-direction:column!important;}',
      scope + ' .formElement_6>.block_label{order:1!important;}',
      scope + ' .formElement_6>.infoMessage{order:2!important;margin:0 0 8px!important;}',
      scope + ' .formElement_6>textarea{order:3!important;}',
      scope + ' .formElement_7{display:flex!important;flex-direction:column!important;}',
      scope + ' .formElement_7:before{content:' + content(copy.upload) + ';order:1;display:block;margin:0 0 2px;color:#0e0e0e;font-family:Inter,"Helvetica Neue",system-ui,sans-serif;font-size:13px;font-weight:600;line-height:1.6;}',
      scope + ' .formElement_7>.infoMessage{order:2!important;margin:0 0 10px!important;}',
      scope + ' .formElement_7>label{display:inline-flex!important;order:3!important;align-self:flex-start!important;align-items:center!important;width:auto!important;min-height:52px!important;margin:0!important;padding:14px 18px!important;border:1px dashed #e5e5e5!important;border-radius:0!important;background:#fff!important;color:transparent!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:0!important;font-weight:400!important;line-height:1.6!important;cursor:pointer!important;}',
      scope + ' .formElement_7>label:before{content:"\\f093";margin-right:12px;color:#0e0e0e;font-family:FontAwesome!important;font-size:16px!important;font-weight:400!important;line-height:1!important;}',
      scope + ' .formElement_7>label:after{content:' + content(copy.selectFiles) + ';color:#0e0e0e;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:14px!important;font-weight:400!important;line-height:1.6!important;}',
      scope + ' .infoMessage{margin:5px 0 1px!important;padding:0!important;color:#6b6b6b!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:12.5px!important;font-weight:400!important;line-height:1.55!important;}',
      scope + ' .formElement_9 fieldset{display:block!important;width:100%!important;margin:0!important;padding:0!important;border:0!important;}',
      scope + ' .formElement_9 legend{width:100%!important;margin:0 0 12px!important;border:0!important;}',
      scope + ' .formElement_9 .radio-list{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:10px!important;}',
      scope + ' .formElement_9 .radio-list>legend{grid-column:1/-1!important;margin-bottom:2px!important;}',
      scope + ' .radio-inline{display:flex!important;float:none!important;align-items:center!important;width:100%!important;min-height:48px!important;margin:0!important;padding:12px 14px!important;border:1px solid #e5e5e5!important;background:#fff!important;color:#1f1f1f!important;}',
      scope + ' .radio-inline>input[type="radio"]{display:block!important;position:static!important;width:16px!important;height:16px!important;margin:0 10px 0 0!important;opacity:1!important;accent-color:#a4823a!important;appearance:auto!important;}',
      scope + ' .radio-inline>label{display:block!important;position:static!important;width:auto!important;margin:0!important;padding:0!important;color:inherit!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:14px!important;font-weight:400!important;line-height:1.6!important;}',
      scope + ' .radio-inline>label>span{display:none!important;}',
      scope + ' .radio-inline:has(input:checked){border-color:#0e0e0e!important;color:#0e0e0e!important;}',
      scope + ' .formElement_11,' + scope + ' .formElement_13{display:grid!important;grid-template-columns:22px minmax(0,1fr)!important;column-gap:12px!important;align-items:start!important;}',
      scope + ' .formElement_11 .checkbox-list,' + scope + ' .formElement_13 .checkbox-list,' + scope + ' .formElement_11 .checkbox-inline,' + scope + ' .formElement_13 .checkbox-inline{display:contents!important;}',
      scope + ' .formElement_11 input[type="checkbox"],' + scope + ' .formElement_13 input[type="checkbox"]{display:block!important;grid-column:1!important;grid-row:1/span 2!important;position:static!important;width:18px!important;height:18px!important;margin:2px 0 0!important;opacity:1!important;accent-color:#0e0e0e!important;appearance:auto!important;}',
      scope + ' .formElement_11 label[for="Checkbox_11"],' + scope + ' .formElement_13 label[for="Checkbox_13"]{display:block!important;grid-column:2!important;grid-row:1!important;margin:0 0 2px!important;padding:0!important;color:transparent!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:0!important;font-weight:600!important;line-height:1.6!important;}',
      scope + ' .formElement_11 label[for="Checkbox_11"]:before{content:' + content(copy.privacy) + ';color:#0e0e0e;font-size:13px;}',
      scope + ' .formElement_13 label[for="Checkbox_13"]:before{content:' + content(copy.contact) + ';color:#0e0e0e;font-size:13px;}',
      scope + ' .formElement_11 label[for="Checkbox_11"]:after,' + scope + ' .formElement_13 label[for="Checkbox_13"]:after{content:" *";color:#b8332b;font-size:13px;}',
      scope + ' .formElement_11 label[for="Checkbox_11"]>span,' + scope + ' .formElement_13 label[for="Checkbox_13"]>span{display:none!important;}',
      scope + ' .formElement_11>.infoMessage,' + scope + ' .formElement_13>.infoMessage{grid-column:2!important;grid-row:2!important;margin:0!important;font-size:13px!important;line-height:1.6!important;}',
      scope + ' .form_submit_div{clear:both!important;margin:6px 0 0!important;padding:0!important;text-align:left!important;}',
      scope + ' .form_submit_div .btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:220px!important;min-width:220px!important;height:52px!important;margin:0!important;padding:0 28px!important;border:1px solid #0e0e0e!important;border-radius:0!important;background:#0e0e0e!important;color:#fff!important;font-family:Inter,"Helvetica Neue",system-ui,sans-serif!important;font-size:14px!important;font-weight:500!important;line-height:14px!important;letter-spacing:.02em!important;text-transform:none!important;box-shadow:none!important;}',
      parentViewportWidth <= 1100 && parentViewportWidth > 640 ? scope + ' .formElement_9 .radio-list{grid-template-columns:repeat(2,minmax(0,1fr))!important;}' : '',
      '@media(max-width:640px){' + scope + ' .formElement_0,' + scope + ' .formElement_1{float:none!important;clear:both!important;width:100%!important;margin-right:0!important;}' + scope + ' .phone_div{grid-template-columns:1fr!important;}' + scope + ' .formElement_9 .radio-list{grid-template-columns:1fr!important;}' + scope + ' .form_submit_div .btn{width:100%!important;min-width:0!important;}}'
    ].join('');

    formData.advance_css = cssPatch;
    formData.form_width = '720px';
    formData.form_padding = '0';
    formData.form_border_size = 0;
    formData.form_submit = english ? 'Submit' : 'Absenden';

    iframeThemeSettingsPatch = {
      form_uuid: FORM_ID,
      form_settings: 'true',
      fill_color: 'transparent',
      padding: '0',
      border_color: '#e5e5e5',
      border_radius: '0',
      border: '0',
      form_width: '720',
      fonts: 'Inter, sans-serif',
      font_color: '#0e0e0e',
      size: '13',
      btn_text: english ? 'Submit' : 'Absenden',
      sub_btn_bg_color: '#0e0e0e',
      sub_btn_txt_color: '#ffffff',
      sub_btn_bdr_rad: '0',
      sub_btn_font_size: '14',
      sub_btn_bdr_width: '0',
      sub_btn_bdr_color: '#0e0e0e',
      input_font_color: '#0e0e0e',
      input_size: '15',
      input_background_color: '#ffffff',
      input_border_radius: '0',
      input_border_color: '#e5e5e5',
      input_background_color_focus: '#ffffff',
      input_border_color_focus: '#0e0e0e !important;} ' + cssPatch + ' /*'
    };
  }

  applyEnglishFormCopy();
  applyIframeDesignPatch();

  var assetUrl = 'https://www.colognewatch.de/cdn/shop/t/137/assets/cw-hulk-watch-purchase-form-locale-20260518.js';

  try {
    if (document.currentScript && document.currentScript.src) {
      assetUrl = new URL('cw-hulk-watch-purchase-form-locale-20260518.js', document.currentScript.src).toString();
    }
  } catch (error) {}

  assetUrl = assetUrl.split('?')[0];
  assetUrl += '?cw_v=20260722-watch-purchase-redesign-v1';

  formData.advance_js = '(function(){var s=document.createElement("script");s.src=' + JSON.stringify(assetUrl) + ';document.head.appendChild(s);}());';
  var a11yFrame = document.querySelector('iframe[src*="formbuilder.hulkapps.com/corepage/customform"][src*="' + FORM_ID + '"]');
  if (a11yFrame) enableIframeA11y(a11yFrame.contentWindow);
})();
